import uniq from 'lodash/uniq';
import moment from 'moment';
import { IColumn } from '@components/sources/source/warehouseSource/configureData/sourceSpecificConfig/types';
import { Mapping } from '@stores/source/types';

export const SYNC_BEHAVIOUR_MODES = {
  UPSERT: 'upsert',
  MIRROR: 'mirror',
};

export const updateMappings = (
  mappings: { original: string; mapped: string }[],
  columns: string[],
  overridesConfig: { [i: string]: string },
) => {
  const newMappings = mappings?.reduce((accum: { original: string; mapped: string }[], col) => {
    if (
      col.mapped &&
      (columns.includes(col.original) || Object.keys(overridesConfig).includes(col.mapped))
    ) {
      accum.push(col);
    }

    return accum;
  }, []);
  return newMappings;
};

export const addUserIdInColumns = (
  mappings: { original: string; mapped: string }[],
  columns: string[],
  overridesConfig: { [i: string]: string },
) => {
  columns = columns || [];
  const columns_to_add = Object.values(overridesConfig || []).filter(
    (col) => !columns.includes(col),
  );
  columns.push(...columns_to_add);

  const filtered_original_cols = mappings?.reduce((acc: string[], { original }: Mapping) => {
    if (!acc.includes(original)) {
      acc.push(original);
    }
    return acc;
  }, []);

  columns = columns.filter((col) => filtered_original_cols.includes(col));
  return uniq(columns);
};

export const generatePreview = (rows: Array<Record<string, unknown>>, columns: IColumn[]) => {
  if (!rows || rows.length === 0) {
    /**
     * for future if we want to allow mapping and show preview with null values
     * preview = rows ? rows[0] : {}
     * and instead of returning {} we can return tableData
     *  */
    return {};
  }
  const preview = rows[0];
  const tableData = columns.reduce((accum: { [column: string]: unknown }, col) => {
    const currentValue = preview[col.name];
    const newAccum = accum;
    newAccum[col.name] = currentValue;
    return accum;
  }, {});
  return tableData;
};

export const convertToHourlyUTC = (t: string, method: 'ceil' | 'floor') => {
  // t is in UTC format
  if (method === 'floor') {
    return moment(t).utc().minutes(0).seconds(0).milliseconds(0).toISOString();
  }

  return moment(t).utc().add(1, 'hours').minutes(0).seconds(0).milliseconds(0).toISOString();
};
